import ProductCard from "./ProductCard";
import ShopContext from "^/ShopContext";
import {useContext} from 'react';
import {Spinner} from 'react-bootstrap';
const ProductGrid = (props) => {

  const {
    list
  } = props;
  const {
    catProdLoading
  } = useContext(ShopContext);

  if(list?.map?.length) {
    document.querySelector('#init-product-grid')?.remove();
  }

  return (
    <div className='grid product-grid'>
      {
        catProdLoading ? 
        <Spinner />
        :
        list?.map(each => 
          <ProductCard 
            {...each}
            key={each.id}
          
          />
          
          )
      }
    </div>
  )
}
export default ProductGrid;